import api, {
  setHeaderToken,
  removeHeaderToken
} from '../../../apis/Api';

import router from '@/router'

export default {
  namespaced: true,
  state: {
    docFaqList: {},
  },
  getters: {
    getDocFaqList(state) {
      return state.docFaqList;
    },
  },
  mutations: {
    setDocFaqList(state, payload) {
      state.docFaqList = payload;
    },
  },
  actions: {
    createDocFaq({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = sessionStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: payload.method,
          url: payload.url,
          data: payload.data,
          withCredentials: true,
          headers: {
            'Authorization': 'Bearer ' + token,
          }
        }).then((res) => {
          resolve(res)
          dispatch('setLoading', false)
        }).catch((err) => {
          console.log('authjs=err' + err)
          reject(err);
          dispatch('setLoading', false)
          return false
        })
      })
    },
    getDocFaqList({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = sessionStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          commit("setDocFaqList", res.respond.data);
        } else if (res.respond.status == "forbidden") {
          sessionStorage.removeItem("token")
          sessionStorage.removeItem("refreshToken")
          router.push(`/login`).catch(() => { });
        }
        dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        dispatch('setLoading', false)
        return false
      })
    },

    setLoading({
      commit
    }, payload) {
      commit("loader/setLoading", payload, {
        root: true,
      });
    },
  },
};